import React from 'react';
import { Download, Search, Shield } from 'lucide-react';
export function HowItWorks() {
  return <section className="py-20 px-4 bg-white" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center text-slate-900 mb-16" data-id="element-112">
          Cómo funciona
        </h2>

        <div className="relative" data-id="element-113">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-teal-100 -translate-y-1/2 z-0" data-id="element-114"></div>

          <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-115">
            <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-lg text-center relative" data-id="element-116">
              <div className="w-16 h-16 mx-auto bg-teal-600 text-white rounded-full flex items-center justify-center mb-6 shadow-md border-4 border-white" data-id="element-117">
                <Download className="w-8 h-8" data-id="element-118" />
              </div>
              <h3 className="font-bold text-xl text-slate-900 mb-3" data-id="element-119">
                Paso 1: Choque
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-120">
                Descarga el manual y realiza el "Protocolo de Choque" esta misma
                noche.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-lg text-center relative" data-id="element-121">
              <div className="w-16 h-16 mx-auto bg-teal-600 text-white rounded-full flex items-center justify-center mb-6 shadow-md border-4 border-white" data-id="element-122">
                <Search className="w-8 h-8" data-id="element-123" />
              </div>
              <h3 className="font-bold text-xl text-slate-900 mb-3" data-id="element-124">
                Paso 2: Vigilancia
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-125">
                Sigue el calendario de vigilancia de 10 minutos durante la
                semana.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-lg text-center relative" data-id="element-126">
              <div className="w-16 h-16 mx-auto bg-teal-600 text-white rounded-full flex items-center justify-center mb-6 shadow-md border-4 border-white" data-id="element-127">
                <Shield className="w-8 h-8" data-id="element-128" />
              </div>
              <h3 className="font-bold text-xl text-slate-900 mb-3" data-id="element-129">
                Paso 3: Cierre
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-130">
                Aplica el cierre de ciclo en el Día 7 para asegurar que el
                problema no regrese jamás.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}